// extracted by mini-css-extract-plugin
export var visuallyHidden = "visually-hidden-module--visuallyHidden--a72ca";